import { render } from "./privacyAgreementView.vue?vue&type=template&id=37ec0afa&scoped=true"
import script from "./privacyAgreementView.vue?vue&type=script&lang=js"
export * from "./privacyAgreementView.vue?vue&type=script&lang=js"

import "./privacyAgreementView.vue?vue&type=style&index=0&id=37ec0afa&lang=less&scoped=true"

import exportComponent from "/Users/baojian/Documents/coipor/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ec0afa"]])

export default __exports__